/**
 * View image block.
 * @module components/manage/Blocks/Hero/View
 */

import React from 'react';
import PropTypes from 'prop-types';
import { flattenToAppURL } from '@plone/volto/helpers';
import { TextBlockView } from '@plone/volto-slate/blocks/Text';
import { Container } from 'semantic-ui-react';
import cx from 'classnames';
/**
 * View image block class.
 * @class View
 * @extends Component
 */
const View = ({ data, className }) => (
  <div className={cx(className, 'block hero view full-width')}>
    <Container>
      <div className="block-inner-wrapper">
        {data.url && (
          <div className="image-widget-wrapper">
            <div className="image-wrapper">
              <img
                src={`${flattenToAppURL(data.url)}/@@images/image`}
                alt=""
                className="hero-image"
                loading="lazy"
              />
            </div>
          </div>
        )}
        <div className="hero-body">
          <div className="hero-text">
            <p>
              <TextBlockView data={{ value: data?.text ?? {} }} />
            </p>
          </div>
        </div>
      </div>
    </Container>
  </div>
);

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
